import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="/icons/dev_canary.svg"
								alt="dev_canary"
								className="work-image"
							/>
							<div className="work-title">Dev Canary</div>
							<div className="work-subtitle">
								Founder
							</div>
							<div className="work-duration">2023 - Present</div>
						</div>

						<div className="work">
							<img
								src="./images/tusenti.png"
								alt="tusenti"
								className="work-image"
							/>
							<div className="work-title">Tusenti</div>
							<div className="work-subtitle">
								C.T.O
							</div>
							<div className="work-duration">2022 - Present</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
